module.exports = __webpack_public_path__ + "img/lab-room-bg.0c2d5774.png";